import get from 'lodash/get';
import {
    APPLY_SYF_START,
    APPLY_SYF_START_SUCCESS,
    APPLY_SYF_START_ERROR,
    DECRYPT_SYF_RESULT_START,
    DECRYPT_SYF_RESULT_SUCCESS,
    DECRYPT_SYF_RESULT_ERROR,
    SYF_APPLICATION_GOTO_WALLET,
    SYF_APPLICATION_WALLET_ADD,
    SYF_APPLICATION_WALLET_ADD_SUCCESS,
    SYF_APPLICATION_WALLET_ADD_ERROR,
    SYF_APPLICATION_WALLET_ADD_LOADING,
} from '../actionTypes/ApplySyfActionTypes';

// const store = {
//     forwardFlow: {
//         isLoading: true,
//         error: {},
//         isContinuedAsGuest: false,
//         accountId: 'abcd', // put after success
//         userState: '2', // put after success
//         dataHref: '?something=somewhere&siteCode=gosh',
//     },
//     returnFlow: {
//         isLoading: true,
//         error: {},
//         isWalletAdding: true,
//         walletError: {},
//         decision: 'A|R|D',
//         userState: '0',
//         isSDPValidated: true,
//         addedToWallet: false,
//         dpAccountExist: false,
//     },
// };
// To store state in local storage for better tracking
// only on forward request success & return request success

const initialState = {
    forwardFlow: {},
    returnFlow: {},
};

function ApplySyfReducer(state = initialState, action = {}) {
    switch (action.type) {
        case APPLY_SYF_START: {
            const isLoading = true;
            const isContinuedAsGuest = get(action, 'payload.isContinuedAsGuest', false);
            const dataHref = get(action, 'payload.dataHref', '');
            const sdp = '';
            const forwardFlow = {
                ...state.forward,
                isLoading,
                isContinuedAsGuest,
                dataHref, // this should come from action
            };
            const returnFlow = {};
            return { ...state, sdp, forwardFlow, returnFlow };
        }

        case APPLY_SYF_START_SUCCESS: {
            const {
                data: { accountId, userState, sdp, isContinuedAsGuest, fromVanityPage } = {},
            } = action.payload;

            const forwardFlow = {
                ...state.forwardFlow,
                accountId,
                userState,
                isContinuedAsGuest,
                isLoading: false,
                fromVanityPage,
            };
            return { ...state, sdp, forwardFlow };
        }

        case APPLY_SYF_START_ERROR: {
            const isLoading = false;
            const { error } = action.payload;

            const forwardFlow = {
                ...state.forward,
                error,
                isLoading,
            };
            return { ...state, forwardFlow };
        }

        case DECRYPT_SYF_RESULT_START: {
            const isLoading = true;
            const { sdp } = action.payload;
            const returnFlow = {
                isLoading,
                sdp, // sdp sent to loyalty to decrypt
            };
            return { ...state, returnFlow };
        }

        case DECRYPT_SYF_RESULT_SUCCESS: {
            const { data: { decision, userState, dpAccountExist } = {} } = action.payload;

            const returnFlow = {
                ...state.returnFlow,
                decision,
                userState,
                dpAccountExist,
                isLoading: false,
                addedToWallet: false,
            };
            return { ...state, returnFlow };
        }

        case DECRYPT_SYF_RESULT_ERROR: {
            const { error } = action.payload;
            const returnFlow = {
                ...state.returnFlow,
                isLoading: false,
                error,
            };

            return { ...state, returnFlow };
        }

        case SYF_APPLICATION_WALLET_ADD: {
            const returnFlow = {
                ...state.returnFlow,
                walletError: {},
                addedToWallet: false,
            };
            return { ...state, returnFlow };
        }
        case SYF_APPLICATION_WALLET_ADD_LOADING: {
            const returnFlow = {
                ...state.returnFlow,
                isWalletAdding: true,
            };
            return { ...state, returnFlow };
        }
        case SYF_APPLICATION_WALLET_ADD_SUCCESS: {
            const returnFlow = {
                ...state.returnFlow,
                isWalletAdding: false,
                addedToWallet: true,
            };
            return { ...state, returnFlow };
        }

        case SYF_APPLICATION_WALLET_ADD_ERROR: {
            const { walletError } = action.payload;
            const returnFlow = {
                ...state.returnFlow,
                isWalletAdding: false,
                walletError,
            };
            return { ...state, returnFlow };
        }
        case SYF_APPLICATION_GOTO_WALLET: {
            const returnFlow = {
                ...state.returnFlow,
                gotoWalletCount: (state.gotoWalletCount || 0) + 1,
            };
            return { ...state, returnFlow };
        }
        default:
            return state;
    }
}

ApplySyfReducer.reducerName = 'applySyf';

export default ApplySyfReducer;
